import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Refresh } from '@mui/icons-material';

interface RefreshButtonProps {
  onRefresh: () => void;
  loading?: boolean;
}

const RefreshButton: React.FC<RefreshButtonProps> = ({ onRefresh, loading = false }) => {
  return (
    <Tooltip title={loading ? 'Refreshing...' : 'Refresh data'}>
      <IconButton
        onClick={onRefresh}
        disabled={loading}
        sx={{
          color: 'primary.main',
          '&:hover': {
            backgroundColor: 'primary.50',
          },
          '&:disabled': {
            color: 'primary.main',
            opacity: 0.7,
          },
        }}
      >
        <Refresh
          sx={{
            animation: loading ? 'spin 1s linear infinite' : 'none',
            '@keyframes spin': {
              '0%': { transform: 'rotate(0deg)' },
              '100%': { transform: 'rotate(360deg)' },
            },
          }}
        />
      </IconButton>
    </Tooltip>
  );
};

export default RefreshButton;
